
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/slice/authSlice';
import userReducer from '../store/slice/userSlice';
import permissionReducer from "./slice/permissionSlice";
const middlewareList = [];

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        permissions: permissionReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).concat(middlewareList),

});
